import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getPdfs, uploadPdf, deletePdf } from "../../api/pdfApi";

const AdminOpportunities = () => {
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newPdf, setNewPdf] = useState({ title: "", file: null, date: "" });
  const category = "Opportunities"; // ✅ Ensure category is consistent
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPdfs = async () => {
      try {
        const pdfData = await getPdfs(category);
        console.log("📄 Debugging PDFs:", pdfData); // ✅ Log the response

        const sortedPdfs = pdfData.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPdfs(sortedPdfs);
      } catch (error) {
        console.error("❌ Error fetching PDFs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPdfs();
  }, []);

  const handleUpload = async () => {
    if (!newPdf.file || !newPdf.title || !newPdf.date) {
      alert("Please enter a title, select a PDF file, and choose a date.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("pdfFile", newPdf.file);
      formData.append("title", newPdf.title);
      formData.append("date", newPdf.date); // ✅ Add date
      formData.append("category", category);

      console.log("📤 Preparing to send FormData:", [...formData.entries()]); // ✅ Debugging

      // 🔥 Upload the PDF
      const uploadedPdf = await uploadPdf(formData, category, newPdf.date);
      console.log("✅ Uploaded PDF:", uploadedPdf);

      // ✅ Update state immediately (sorted)
      setPdfs((prev) => [...prev, uploadedPdf].sort((a, b) => new Date(b.date) - new Date(a.date)));

      // ✅ Reset form fields
      setNewPdf({ title: "", file: null, date: "" });
    } catch (error) {
      console.error("❌ Error uploading PDF:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deletePdf(id);
      setPdfs((prev) => prev.filter((pdf) => pdf._id !== id));
    } catch (error) {
      console.error("❌ Error deleting PDF:", error);
    }
  };

  if (loading) return <p className="text-center text-gray-600">Loading PDFs...</p>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Back Button */}
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-3xl font-bold text-center mb-6">Admin - Opportunities</h1>

      {/* PDF Upload Section */}
      <div className="mb-6 border p-4 rounded shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Add New Opportunity</h2>
        <input
          type="text"
          placeholder="Opportunity Title"
          value={newPdf.title}
          onChange={(e) => setNewPdf({ ...newPdf, title: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        />
        <input
          type="date"
          value={newPdf.date}
          onChange={(e) => setNewPdf({ ...newPdf, date: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        />

        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setNewPdf({ ...newPdf, file: e.target.files[0] })}
          className="border rounded p-2 w-full mb-2"
        />
        <button onClick={handleUpload} className="bg-green-500 text-white px-4 py-2 rounded">
          Add PDF
        </button>
      </div>

      {/* Display PDFs (Newest First) */}
      {/* Display PDFs (Newest First) */}
<h2 className="text-2xl font-semibold mb-4">Uploaded Opportunities</h2>
{pdfs.length > 0 ? (
  <div className="flex flex-col gap-2">
    {/* {pdfs.map((pdf) => {
      const pdfLink = pdf.pdfUrl 
        ? pdf.pdfUrl.startsWith("http") 
          ? pdf.pdfUrl 
          : `http://localhost:5555${pdf.pdfUrl}`
        : null; // Handle missing pdfUrl safely */}
        {pdfs.map((pdf) => {
  const rawLink = pdf.pdfUrl || pdf.url || pdf.fileUrl;
  // const pdfLink = rawLink
  //   ? rawLink.startsWith("http")
  //     ? rawLink
  //     : `http://localhost:5555${rawLink.replace(/^\/+/, "")}`
  //   : null;
  const pdfLink = rawLink
    ? rawLink.startsWith("http")
      ? rawLink
      : `${window.location.origin}${rawLink.startsWith("/")
        ? rawLink
        : "/" + rawLink}`
    : null;
      
      return (
        <div key={pdf._id} className="flex justify-between items-center border-b py-2">
          {pdfLink ? (
            <a
              href={pdfLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              {pdf.title || "View PDF"}
            </a>
          ) : (
            <span className="text-red-500">Invalid PDF Link</span> // Show error for missing URLs
          )}
          <button
            className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 transition duration-200"
            onClick={() => handleDelete(pdf._id)}
          >
            Delete
          </button>
        </div>
      );
    })}
  </div>
) : (
  <p className="text-gray-500 italic">No opportunities available.</p>
)}

    </div>
  );
};

export default AdminOpportunities;
